var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5055 5.49493L15.9123 3.08814V0H11.092L11.1054 3.09484L13.5055 5.49493Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5723 15.5371H1.24707C1.4249 18.3322 2.53745 20.873 4.2762 22.8504L10.8694 16.2572C10.7381 16.0285 10.6392 15.7863 10.5723 15.5371Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39551 23.9701C7.37321 25.7091 9.91449 26.8218 12.7102 26.9993V17.6743C12.4605 17.6075 12.2178 17.5085 11.9887 17.377L5.39551 23.9701Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 13.7212C14.2434 13.4383 13.8717 13.2969 13.5002 13.2969C13.1285 13.2969 12.757 13.4383 12.4741 13.7212C11.9084 14.287 11.9084 15.2075 12.4741 15.7733C13.0399 16.339 13.9605 16.3391 14.5262 15.7733C15.0919 15.2075 15.0919 14.2869 14.5262 13.7212Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8693 13.2339L4.27606 6.64062C2.53716 8.6178 1.42414 11.1585 1.24609 13.9536H10.5722C10.6391 13.7045 10.738 13.4624 10.8693 13.2339Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2939 17.6736V26.9994C17.0884 26.8211 19.6284 25.7084 21.6053 23.97L15.0122 17.377C14.7841 17.508 14.5425 17.6067 14.2939 17.6736Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1318 16.2566L22.7251 22.8499C24.4635 20.8726 25.5759 18.332 25.7538 15.5371H16.4285C16.3617 15.7861 16.2629 16.0281 16.1318 16.2566Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7107 11.8188V6.93983L9.52512 3.7543L9.52238 3.12695C7.98718 3.65238 6.58948 4.47382 5.39648 5.52255L11.9897 12.1158C12.2187 11.9845 12.4612 11.8856 12.7107 11.8188Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2939 11.8195C14.5422 11.8864 14.7836 11.985 15.0116 12.1158L21.6046 5.52271C20.4161 4.47778 19.0244 3.65855 17.4959 3.13281V3.74438L14.2939 6.94638V11.8195Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4276 13.955H25.7537C25.5757 11.1601 24.4629 8.61959 22.7242 6.64258L16.1309 13.236C16.262 13.4643 16.3607 13.7062 16.4276 13.955Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.2af43ba0138cebc06ebf7b27cbe3b877.svg";
export { ForwardRef as ReactComponent };